<template>
  <div>
    <modal name="send-modal" height="auto" :adaptive="true" :clickToClose="false">

      <send-print-form :resource="resource" :buttonDef="buttonDef" :data="data"/>

    </modal>
    <div class="page page-print">
      <div class="buttons">
        <h1 class="page-title">{{ t('print_title_buttons') }}</h1>
        <!-- BACK -->
        <button
          @click="_cancelListener"
          type="button"
          class="btn btn-icon btn-dark btn-close"
          aria-label="Close">
          <i class="icon wb-close"></i>
        </button>
        <button
          @click="_print"
          class="btn btn-primary"
          type="button"
          style="margin-right: 1px;"
        >{{ t('btn_print') }}
        </button>
        <button
          v-if="sendIsPossible"
          @click="_send"
          class="btn btn-success"
          type="button"
          style="margin-right: 1px;"
        >{{ t('btn_send_mail') }}
        </button>
      </div>
      <div class="html-content" v-html="content">
      </div>
    </div>
  </div>
</template>

<script>
import Button        from '../../../grids/renderers/grid-form/elements/button'
import SendPrintForm from '../../../widgets/send-print-form'

export default {
  name:       'PageDynamicEditorPrint',
  components: { SendPrintForm, Button },
  props:      ['content', 'resource', 'buttonDef', 'data'],

  data () {
    return {
      sendIsPossible: false
    }
  },

  created () {
    if (this.data && this.data.hasOwnProperty('MF_SENDMAIL_TO')) {
      this.sendIsPossible = true
    }

    if (!this.content) {
      this.$router.go(-1)
    }
  },

  mounted () {
    $(document).on('keydown', (e) => {
      if (e.key === 'Escape') {
        this.$router.go(-1)
      }
    })
  },

  methods: {

    _print () {
      window.print()
    },

    _send () {
      this.$modal.show('send-modal')
    },

    _cancelListener () {
      this.$router.go(-1)
    }

  }

}
</script>

<style>

@media print {
  .buttons,
  .buttons button,
  .page-title,
  .site-navbar.navbar {
    display: none;
  }

  .html-content {
    margin-top: -60px;
  }

  .page.page-print {
    width: 100%;
  }
}

.buttons {
  display: flex;
  justify-content: flex-end;
  background: #FFF;
  padding: 10px;
  margin-top: 10px;
  margin-left: 5px;
  margin-right: 5px;
}

.buttons button {
  margin-left: 3px;
}

body.printable {
  background-color: #FFFFFF;
  padding-top: 0;
}

body.printable .site-navbar {
  display: none;
}

body.printable .site-menubar {
  top: 0;
}

.page.page-print {
  padding: 15px 10px;
}
</style>
